import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusCircle, ChevronUp, Table, Grid } from 'react-feather';
import { ImageWithBasePath } from 'Core/components';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions } from 'Core/redux/main/slice';
import { actions as forkliftActions } from './store/slice';
import { isHeaderVisible } from 'Core/redux/main/selectors';

const { setToogleHeader } = mainActions;
const { setTileView } = forkliftActions;

const ForkliftTopHead = () => {
  const dispatch = useDispatch();
  const data = useSelector(isHeaderVisible);
  const tileView = useSelector(state => state.forklift?.tileView || false);

  const handleAddNew = () => {
    if (window.showForkliftModal) {
      window.showForkliftModal();
    }
  };

  const handleExcelDownload = () => {
    // Excel download functionality
    alert('Excel download functionality will be implemented here');
  };

  const handleToggleView = () => {
    dispatch(setTileView(!tileView));
  };

  const renderExcelTooltip = props => <Tooltip {...props}>Excel</Tooltip>;
  const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
  const renderTileViewTooltip = props => (
    <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
  );

  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={handleExcelDownload}
            >
              <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={data ? 'active' : ''}
              onClick={() => {
                dispatch(setToogleHeader(!data));
              }}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={handleToggleView}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
      <div className="d-flex purchase-pg-btn">
        <div className="page-btn">
          <button
            type="button"
            className="btn btn-added"
            onClick={handleAddNew}
          >
            <PlusCircle className="me-2" />
            Add New Forklift
          </button>
        </div>
      </div>
    </>
  );
};

export default ForkliftTopHead;
